import { ReactNode } from 'react';
import { pxToRem } from 'utils/convert';
import styled from 'styled-components';
import { spacing, caption, colors } from 'ui/theme';
import { Skeleton } from 'ui/skeleton';
import { Link } from 'ui/links';

export const CAMPAIGN_NAME_WITH_CAPTION_TEST_ID = 'name-with-caption';

export const CampaignCaption = styled.div`
  padding-top: ${spacing.quarter};
  ${caption};
  color: ${colors.textSecondary};
`;
export const PreviewContainer = styled.img`
  margin-right: ${spacing.base};
  width: ${pxToRem(56)};
  height: ${pxToRem(48)};
`;

export const StyledImgSkeleton = styled(Skeleton)`
  margin-right: ${spacing.base};
  width: ${pxToRem(56)};
  height: ${pxToRem(48)};
`;

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
`;

type CampaignNameWithCaptionProps = {
  thumbnailSrc?: string;
  value: ReactNode;
  metadata: { campaignType: string; campaignState: string };
  campaignId: number;
};

export const CampaignNameWithCaption = ({
  thumbnailSrc,
  value,
  metadata,
  campaignId,
}: CampaignNameWithCaptionProps) => {
  const { campaignType, campaignState } = metadata;

  return (
    <StyledWrapper data-test={CAMPAIGN_NAME_WITH_CAPTION_TEST_ID}>
      {thumbnailSrc ? <PreviewContainer src={thumbnailSrc} /> : <StyledImgSkeleton />}
      <span>
        <Link
          hasOpenNewTabIcon
          href={`/analytics/campaignPerformance/snippets?campaignId=${campaignId}`}
          target="_blank"
        >
          <span>{value}</span>
        </Link>
        <CampaignCaption>
          {campaignType} | {campaignState}
        </CampaignCaption>
      </span>
    </StyledWrapper>
  );
};
